import React, { useEffect } from "react";
import MainLayout from "../../../../layout/mainLayout";
import "./index.scss";
import { Col, Row } from "react-bootstrap";
import RenewalDetails from "./component/renewalDetails";

import RMCard from "../../../../components/rmCard";
import WhyUs from "./component/whyUs";
import { getRenewalTitle } from "../../../../service/renewal/renewalService";
import { useSelector } from "react-redux";
import { getCodeFromUrl } from "../../../../utils/helper";
import FAQ from "../../../../components/faq";
import { api_strapi } from "../../../../utils/interface";
import Testimonials from "../../../../components/testimonials";

const Renewal = () => {
  const renewalTitle = useSelector((state) => state.renewal.renewalTitles);
  let agCode = getCodeFromUrl().toUpperCase();

  useEffect(() => {
    const getTitles = async () => {
      await getRenewalTitle();
    };
    getTitles();
  }, []);

  const fetchRenewal = async (populateValues) => {
    const response = await api_strapi.get(
      `/ags?filters[slug][$eq]=${agCode}&populate=${populateValues}`
    );

    if (response.status === 200) {
      return response?.data?.data[0]?.attributes;
    }
    return null;
  };

  return (
    <MainLayout>
      <div className="renewal-container">
        <div className="renewal-header">
          <h1 className="head1">{`${renewalTitle?.title} ${agCode} !`}</h1>
          <p className="head2">{renewalTitle?.subtitle}</p>
          <p className="head2"></p>
        </div>
        <Row>
          <Col md={8}>
            <RenewalDetails />
          </Col>
          <Col md={4}>
            <RMCard />
            <WhyUs />
          </Col>
        </Row>
      </div>
      <FAQ
        fetchData={() => fetchRenewal("faqs")}
        title={renewalTitle?.FAQtitle}
        subtitle={renewalTitle?.FAQsubtitle}
      />
      <Testimonials
        fetchData={() =>
          fetchRenewal("testimonials,testimonials.profilePicture")
        }
        title={renewalTitle?.testimonialsTitle}
      />
    </MainLayout>
  );
};

export default Renewal;
